import { useState } from 'react';
import { ImagePreviewFormatter } from '../../../../components/UIElements/Formatter';

export default function MediaPreview({ receiptData, setIsAlertVisible }) {
    const [imageError, setImageError] = useState(false);
    return (
        <div>
            <div className="row g-3">
                <div className="col-12">
                    <div className="d-flex flex-wrap">
                        <div
                            className="imgPreviewBox m-1 position-relative"
                        >
                        {receiptData?.Booking?.BookingDetail?.providerPaymentStatus === 'unsettelled' && <a to='#' onClick={() => setIsAlertVisible(true)} class="imgPreviewBox_deleteicon"><em class="icon ni ni-trash"></em></a>}
                            <ImagePreviewFormatter
                                path={receiptData?.receiptUrl}
                                text="Image"
                                setImageError={setImageError}
                                imageError={imageError}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
